import { axios } from "../../../core/axios";
import { GetDashboardRequest, GetDashboardResponse } from "../types";

export const dashboardEndpoints = {
  getDashboard: async (
    props: GetDashboardRequest
  ): Promise<GetDashboardResponse | undefined> => {
    try {
        const response = await axios.get<GetDashboardResponse>(`/dashboards/${props.userRefId}/${props.dashboardId}`);

        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard:", error);
        return;
    }
  },

  createDashboard: async (
    props: GetDashboardRequest
  ): Promise<GetDashboardResponse | undefined> => {
    try {
      const response = await axios.post<GetDashboardResponse>(
        `/dashboards/${props.dashboardId}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard:", error);
      return;
    }
  },
};
